module.exports = Em.Controller.extend({
    // Route props
    code: null,
    organization: null
})
